/**
 * client/src/services/keepalive.ts
 *
 * FASE 1.5 — Keepalive Service
 *
 * Mantiene caldo il server Render free tier chiamando periodicamente
 * l'endpoint /health/keepalive (fire-and-forget, nessun impatto su UI).
 *
 * Il keepalive si attiva automaticamente quando l'utente è autenticato.
 * Intervallo: 14 minuti (Render free tier spindown a 15 minuti di inattività).
 */
 
import { resolveApiBaseUrl } from "@/utils/apiBase";

const KEEPALIVE_INTERVAL_MS = 14 * 60 * 1000; // 14 minuti
const KEEPALIVE_ENDPOINT = "/health/keepalive";

let _keepaliveTimer: ReturnType<typeof setInterval> | null = null;
let _apiBase = "";

function getApiBase(): string {
  if (_apiBase) return _apiBase;
  _apiBase = resolveApiBaseUrl();
  return _apiBase;
}

async function ping(): Promise<void> {
  try {
    const url = `${getApiBase()}${KEEPALIVE_ENDPOINT}`;
    // Fire-and-forget: non aspettiamo la risposta
    fetch(url, { method: "GET", cache: "no-cache", keepalive: true }).catch(() => {});
  } catch {
    // Silenzioso — il keepalive è best-effort
  }
}

/**
 * Avvia il keepalive periodico.
 * Chiamare dopo il login. Idempotente (non crea timer duplicati).
 */
export function startKeepalive(): void {
  if (_keepaliveTimer) return;
  ping(); // Prima chiamata immediata
  _keepaliveTimer = setInterval(ping, KEEPALIVE_INTERVAL_MS);
  console.debug("[Keepalive] Started (interval: 14min)");
}

/**
 * Ferma il keepalive periodico.
 * Chiamare al logout o quando l'app va in background.
 */
export function stopKeepalive(): void {
  if (!_keepaliveTimer) return;
  clearInterval(_keepaliveTimer);
  _keepaliveTimer = null;
  console.debug("[Keepalive] Stopped");
}

/**
 * Verifica se il keepalive è attivo.
 */
export function isKeepaliveActive(): boolean {
  return _keepaliveTimer !== null;
}
